import { statusPresentation, type AppSummary, type DeploymentRun } from './api';
import type { TagVariant } from './ds';

export function appStatusPresentation(app: AppSummary, runs: Pick<DeploymentRun, 'environment' | 'status'>[] = []): { label: string; variant: TagVariant } {
  if (app.archived) return { label: 'Archived', variant: 'default' };
  const active = runs.filter(run => run.status === 'queued' || run.status === 'in_progress');
  const dev = active.some(run => run.environment === 'dev');
  const prod = active.some(run => run.environment === 'prod');
  const running = active.some(run => run.status === 'in_progress');
  if (dev && prod) return { label: running ? 'Updating Dev & Prod' : 'Dev & Prod updates queued', variant: running ? 'info' : 'warning' };
  if (dev) return { label: running ? 'Deploying to Dev' : 'Dev deployment queued', variant: running ? 'info' : 'warning' };
  if (prod) return { label: running ? 'Promoting to Prod' : 'Prod promotion queued', variant: running ? 'info' : 'warning' };
  if (app.readiness.state === 'ready') return { label: 'Live', variant: 'success' };
  if (app.readiness.state === 'unavailable') return { label: 'Readiness unavailable', variant: 'default' };
  return statusPresentation(app.status);
}
